// Export all product components as convenience
export * from '../Product';
// Wine-specific components
export { default as Blend } from './Blend';
export { default as CellarMaster } from './CellarMaster';
export { default as Classification } from './Classification';
export { default as Fermentation } from './Fermentation';
export { default as FermentationVessels } from './FermentationVessels';
export { default as Maturation } from './Maturation';
export { default as Origin } from './Origin';
export { default as PH } from './PH';
export { default as PrimarySoilType } from './PrimarySoilType';
export { default as PrimaryVariety } from './PrimaryVariety';
export { default as ResidualSugar } from './ResidualSugar';
export { default as SoilTypeDescription } from './SoilTypeDescription';
export { default as SoilTypes } from './SoilTypes';
export { default as TotalAcidity } from './TotalAcidity';
export { default as Vintage } from './Vintage';
export { default as WineColor } from './WineColor';
export { default as VineyardAge } from './VineyardAge';
export { default as VineyardElevation } from './VineyardElevation';
export { default as VineyardInformation } from './VineyardInformation';
export { default as Vinification } from './Vinification';
export { default as Viticulture } from './Viticulture';
export { default as WholeClusterPercent } from './WholeClusterPercent';
export { default as fragment } from './wineFragment';
